import { render, staticRenderFns } from "./ResumeStep.vue?vue&type=template&id=a71b163a&"
import script from "./ResumeStep.vue?vue&type=script&lang=js&"
export * from "./ResumeStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports